import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import SideBar from "./sideBar";

import ProtectedRoute from "./ProtectedRoute";
import LayoutHeader from "./layoutHeader";

import Employee from "../hr/employee/employee";
import Developer from "../hr/employee/developer/developer";
import Accountant from "../hr/employee/accountant/accountant";
import Designer from "../hr/employee/designer/designer";
import Freelancer from "../hr/employee/freelancer/freelancer";
import Telecaller from "../hr/employee/telecaller/telecaller";
import Viewuser from "../hr/employee/viewuser";
import ViewClient from "../hr/client/viewclient";
import ViewProject from "../hr/project/viewProject";
import Receptionist from "../hr/employee/receptionist/receptionist";
import Projectindex from "../hr/project";
import ClientIndex from "../hr/client";
import ViewTaskData from "../hr/task/viewTaskData";
import VisitorsDetails from "../hr/receptionist/visitorsDetails/visitorsDetails";
import UpdateVisitors from "../hr/receptionist/visitorsDetails/updateVisitors";
import TelecallerIndex from "../hr/receptionist/telecallerDetails/telecallerIndex";
import InvoiceGenerator from "../hr/invoice/invoice";
import LeaveDetailsAdmin from "../hr/leaveDetails/leaveDetails";
import LeaveupdateDetails from "../hr/leaveDetails/leaveupdateDetails";
import Dashboard from "../hr/dashboard/dashboard";
import HRDashboard from "../hr/dashboard/dashboard";
import MonthlyReportIndex from "../hr/monthlyReport/monthlyReportIndex";
import UpdateMonthlyReport from "../hr/monthlyReport/updateMonthlyReport";
import MonthlyReport from "../hr/monthlyReport/monthlyReport";
import UpdateMonthlyPlanner from "../hr/monthlyPlanner/updateMonthlyPlanner";
import Monthlyplanner from "../hr/monthlyPlanner/monthlyplanner";
import IndexMonthlyplanner from "../hr/monthlyPlanner/indexMonthlyplanner";
import InvoiceIndexHR from "../hr/invoice/invoiceIndex";
import InvoiceGeneratorHr from "../hr/invoice/invoice";
import UpdateInvoiceHr from "../hr/invoice/updateInvoice";
import HrInternshipIndex from "../hr/internship/internshipIndex";
import HrUpdateInternship from "../hr/internship/updateInternship";

const HRNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBar
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            {/* Redirect root (/) to /login if the user is not authenticated */}
            <Route path="/" element={<HRDashboard />} />

            <Route
              path="/Dashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <HRDashboard />
                </ProtectedRoute>
              }
            />

            {/* <Route path="/*" element={<Login />} /> */}

            <Route
              path="/Employee"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Employee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Developer"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Developer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Accountant"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Accountant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Designer"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Designer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Freelancer"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Freelancer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Telecaller"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Telecaller />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Employee/viewuser/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Viewuser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client/viewclient/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project/projectview/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Receptionist"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Receptionist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Projectindex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientIndex />
                </ProtectedRoute>
              }
            />

            <Route
              path="/task_view/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewTaskData />
                </ProtectedRoute>
              }
            />

            <Route
              path="/VisitorsDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <VisitorsDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/VisitorsDetails/update/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateVisitors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/TelecallerDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Invoice"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <InvoiceIndexHR />
                </ProtectedRoute>
              }
            />
            <Route
              path="Invoice/createinvoice"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <InvoiceGeneratorHr />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Invoice/viewinvoice/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateInvoiceHr />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Leave"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveDetailsAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leave-update/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveupdateDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Monthlyplanner"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <IndexMonthlyplanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Monthlyplanner/planner/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Monthlyplanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Monthlyplanner/planner/Edit/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateMonthlyPlanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/MonthlyReport"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <MonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/MonthlyReport/Report/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <MonthlyReportIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/MonthlyReport/Report/Edit/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateMonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HrInternshipIndex"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <HrInternshipIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="HrInternshipIndex/updateInternship/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <HrUpdateInternship />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default HRNavigation;
